var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter content"
  }, [_c('h5', [_vm._v("COI Solutions, " + _vm._s(_vm.getYear()))]), _vm._v(" "), _c('div', [_c('p', [_vm._v("We help independent insurance brokers automate certificate of insurance requests.")]), _vm._v(" "), _c('a', {
    staticClass: " is-small",
    on: {
      "click": function($event) {
        _vm.showContactForm = true
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Contact Us")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showContactForm
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  })]), _vm._v(" "), (!_vm.contactSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter your email address"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter your message, we'll respond as quickly as possible"
    },
    domProps: {
      "value": (_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.sendContactMessage(_vm.contact)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.contactSuccess) ? _c('div', [_vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you for contacting us. We will return your message as soon as possible.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66192e76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Footer.vue
// module id = 4N5N
// module chunks = 1